export function localTodayIso(): string {
    const d = new Date()
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
}

export function localCurrentMonthIso(): string {
    return localTodayIso().slice(0, 7)
}

const WEEKDAY = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']

const WEEKDAY_FULL = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']

export function weekdayDayLabel(iso: string): string {
    const d = new Date(iso + 'T00:00:00Z')
    return `${WEEKDAY_FULL[d.getUTCDay()]} ${d.getUTCDate()}`
}

const MONTHS_SHORT = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

export function addDaysIso(iso: string, n: number): string {
    const d = new Date(iso + 'T00:00:00Z')
    d.setUTCDate(d.getUTCDate() + n)
    return d.toISOString().slice(0, 10)
}

export function addMonths(month: string, n: number): string {
    const [y, m] = month.split('-').map(Number)
    return new Date(Date.UTC(y, m - 1 + n, 1)).toISOString().slice(0, 7)
}

export function monthEndIso(monthStart: string): string {
    return addDaysIso(addDaysIso(monthStart, 32).slice(0, 7) + '-01', -1)
}

export function daysBetween(from: string, to: string): number {
    return Math.round((Date.parse(to + 'T00:00:00Z') - Date.parse(from + 'T00:00:00Z')) / 86400000)
}

export function labelOf(iso: string): { label: string; weekday: string } {
    const d = new Date(iso + 'T00:00:00Z')
    const weekday = WEEKDAY[d.getUTCDay()]
    return { label: `${weekday} ${d.getUTCDate()}`, weekday }
}

export function monthDay(iso: string): string {
    return `${MONTHS_SHORT[Number(iso.slice(5, 7)) - 1]} ${Number(iso.slice(8, 10))}`
}

export function isoParts(iso: string): { weekYear: number; week: number; weekday: number } {
    const d = new Date(iso + 'T00:00:00Z')
    const weekday = ((d.getUTCDay() + 6) % 7) + 1
    const thursday = new Date(d)
    thursday.setUTCDate(d.getUTCDate() - (weekday - 1) + 3)
    const weekYear = thursday.getUTCFullYear()
    const jan1 = new Date(Date.UTC(weekYear, 0, 1))
    const jan1Weekday = ((jan1.getUTCDay() + 6) % 7) + 1
    const firstThursday = new Date(jan1)
    firstThursday.setUTCDate(jan1.getUTCDate() + ((4 - jan1Weekday + 7) % 7))
    const week = 1 + Math.round((thursday.getTime() - firstThursday.getTime()) / (7 * 24 * 3600 * 1000))
    return { weekYear, week, weekday }
}

export function isoFromParts(weekYear: number, week: number, weekday: number): string {
    const jan4 = new Date(Date.UTC(weekYear, 0, 4))
    const jan4Weekday = ((jan4.getUTCDay() + 6) % 7) + 1
    const week1Monday = new Date(jan4)
    week1Monday.setUTCDate(jan4.getUTCDate() - (jan4Weekday - 1))
    const target = new Date(week1Monday)
    target.setUTCDate(week1Monday.getUTCDate() + (week - 1) * 7 + (weekday - 1))
    return target.toISOString().slice(0, 10)
}

export function currentWeekIso(): { start: string; end: string } {
    const today = localTodayIso()
    const { weekday } = isoParts(today)
    const start = addDaysIso(today, -(weekday - 1))
    return { start, end: addDaysIso(start, 6) }
}

export function priorYearIso(iso: string): string {
    const { weekYear, week, weekday } = isoParts(iso)
    return isoFromParts(weekYear - 1, week, weekday)
}

export function priorYearLabel(iso: string): string {
    return String(isoParts(iso).weekYear - 1)
}
